import { graphql, useStaticQuery } from "gatsby";
import gsap from "gsap";
import React, { useState } from "react";
import { Button, Card, Col, Container, Row } from "react-bootstrap";
import { FiMapPin } from "react-icons/fi";
import { MdAccessTime, MdKeyboardArrowRight } from "react-icons/md";
import { SafeHtmlParser } from "./SafeHtmlParser";

const Career = ({ colour, activeRole, setActiveRole }) => {
	const [activeDepartment, setActiveDepartment] = useState("View All");
	const [showFullDescription, setShowFullDescription] = useState([]);
	const handleMouseEnter = (e, colour) => {
		gsap.to(e.target, { color: colour, duration: 0.1 });
	};

	const handleMouseLeave = (e) => {
		gsap.to(e.target, { color: "#000", duration: 0.1 });
	};

	// GraphQL Query
	const data = useStaticQuery(graphql`
		query {
			allWpJob {
				nodes {
					jobFields {
						contractType
						description
						location
						salary
					}
					title
					jobDepartments {
						nodes {
							name
						}
					}
				}
			}
			allWpJobDepartment {
				nodes {
					name
				}
			}
		}
	`);

	// Extract data
	const positions = data.allWpJob.nodes.map((job) => ({
		title: job.title,
		salary: job.jobFields.salary,
		department: job.jobDepartments?.nodes[0]?.name || "General",
		description: job.jobFields.description,
		location: job.jobFields.location,
		contractType: job.jobFields.contractType,
	}));
	console.log(positions);

	const departmentsWithJobs = Array.from(
		new Set(positions.map((position) => position.department))
	);

	const filteredPositions =
		activeDepartment === "View All"
			? positions
			: positions.filter(
					(position) => position.department === activeDepartment
			  );

	const scrollToForm = () => {
		const formElement = document.getElementById("multi-form");
		if (formElement) {
			formElement.scrollIntoView({ behavior: "smooth", block: "start" });
		}
	};

	const handleApplyNow = (position) => {
		setActiveRole(position); // Update the active role in the parent state
		console.log(activeRole);
		scrollToForm(); // Scroll to the target section
	};

	return (
		<section className="py-5 py-lg-7">
			<Container>
				{/* Department Filters */}
				<Row className="text-center mb-5">
					<Col>
						<div className="d-flex flex-wrap justify-content-center gap-3">
							{["View All", ...departmentsWithJobs].map((department, index) => (
								<Button
									className="py-2 px-4 "
									key={index}
									variant={
										activeDepartment === department
											? "warning"
											: "outline-warning"
									}
									onClick={() => setActiveDepartment(department)}
									style={{
										borderRadius: "0px",

										borderColor:
											activeDepartment === department ? colour : undefined,
										color: activeDepartment === department ? colour : undefined,
									}}
								>
									{department}
								</Button>
							))}
						</div>
					</Col>
				</Row>
				<Row className="justify-content-center">
					<Col lg={10} xl={8}>
						{/* Job Listings */}
						<Row>
							{filteredPositions.map((position, index) => {
								// Initialize state for each position (Note: This is only valid if this code block is inside
								// a functional component and not at the top-level of the return statement.
								// For best practices, extract this into a separate child component.)

								// Convert HTML to plain text for truncation
								let plainText = "";
								let needsTruncation = false;
								let truncatedText = "";

								if (typeof document !== "undefined") {
									const tempDiv = document.createElement("div");
									tempDiv.innerHTML = position.description;
									plainText = tempDiv.textContent || tempDiv.innerText || "";
								} else {
									plainText = position.description || ""; // Fallback in case 'document' is not defined
								}

								const maxWords = 30;
								const words = plainText.split(" ");
								needsTruncation = words.length > maxWords;
								truncatedText = needsTruncation
									? words.slice(0, maxWords).join(" ") + "..."
									: plainText;

								return (
									<Col xs={12} key={index} className="mb-4">
										<Card
											className=" "
											style={{
												border: `1px solid ${
													activeRole === position.title ? colour : "#CEE4FF"
												}`,
												backgroundColor: "#fff",
												borderRadius: "12px",
											}}
										>
											<Card.Body className="p-3 p-md-4">
												{/* Job Details */}
												<div>
													<div className=" d-none d-md-flex  align-items-center">
														<h5
															style={{ maxWidth: "70%" }}
															className=" mb-0 me-3 d-md-none d-lg-inline-block"
														>
															{position.title}
														</h5>

														<h5
															style={{ maxWidth: "60%" }}
															className=" mb-0 me-3  d-lg-none"
														>
															{position.title}
														</h5>

														<div className="p-1 px-2  position-relative">
															<div
																style={{ background: colour, opacity: 0.1 }}
																className="position-absolute w-100 h-100 start-0 top-0"
															></div>
															<p
																style={{ zIndex: 2, fontSize: "90%" }}
																className="outfit-regular position-relative py-0 my-0"
															>
																{position.department}
															</p>
														</div>
														<div className="ms-3 ms-auto">
															<div className="d-flex align-items-center">
																<a
																	onMouseEnter={(e) =>
																		handleMouseEnter(e, colour)
																	}
																	style={{ color: "black", cursor: "pointer" }}
																	onMouseLeave={handleMouseLeave}
																	className="outfit-regular text-decoration-none  mb-0 pb-0"
																	onClick={() => handleApplyNow(position.title)}
																>
																	Apply now{" "}
																</a>
																<span style={{ color: colour }}>
																	<MdKeyboardArrowRight className="fs-5 ms-1" />
																</span>
															</div>
														</div>
													</div>
													<h6
														className=" d-none d-md-block mt-2"
														style={{ color: "#5F5F5F" }}
													>
														{position.salary}
													</h6>
													<div className="d-md-none   ">
														<h5 className="  me-3">{position.title}</h5>
														<h6 className="  mb-4" style={{ color: "#5F5F5F" }}>
															{position.salary}
														</h6>
														<div className="d-flex  align-items-center ">
															<div className="p-1 px-2  position-relative">
																<div
																	style={{ background: colour, opacity: 0.1 }}
																	className="position-absolute w-100 h-100 start-0 top-0"
																></div>
																<p
																	style={{ zIndex: 2, fontSize: "90%" }}
																	className="outfit-regular position-relative py-0 my-0"
																>
																	{position.department}
																</p>
															</div>
															<div className="ms-3 ms-auto">
																<div className="d-flex align-items-center">
																	<a
																		onMouseEnter={(e) =>
																			handleMouseEnter(e, colour)
																		}
																		style={{
																			color: "black",
																			cursor: "pointer",
																		}}
																		onMouseLeave={handleMouseLeave}
																		className="outfit-regular text-decoration-none  mb-0 pb-0"
																		onClick={() =>
																			handleApplyNow(position.title)
																		}
																	>
																		Apply now{" "}
																	</a>
																	<span style={{ color: colour }}>
																		<MdKeyboardArrowRight className="fs-5 ms-1" />
																	</span>
																</div>
															</div>
														</div>
													</div>
													<div className=" py-4 mb-0">
														{showFullDescription.includes(index) ? (
															<SafeHtmlParser
																htmlContent={position.description}
															/>
														) : (
															<>
																{truncatedText}{" "}
																{needsTruncation && (
																	<div className="d-block mt-2">
																		<span
																			onClick={() =>
																				setShowFullDescription((prev) => [
																					...prev,
																					index,
																				])
																			}
																			style={{
																				color: colour,
																				cursor: "pointer",
																			}}
																		>
																			Read more
																		</span>
																	</div>
																)}
															</>
														)}
													</div>

													<div className="d-flex align-items-center gap-4 ">
														<div>
															<FiMapPin
																className="fs-5 me-2"
																style={{ color: colour }}
															/>
															{position.location}
														</div>
														<div>
															<MdAccessTime
																className="fs-5 me-2"
																style={{ color: colour }}
															/>
															{position.contractType}
														</div>
														{showFullDescription.includes(index) && (
															<div className="ms-auto d-none d-md-inline-block">
																<a
																	onMouseEnter={(e) =>
																		handleMouseEnter(e, colour)
																	}
																	style={{ color: "black", cursor: "pointer" }}
																	onMouseLeave={handleMouseLeave}
																	className="outfit-regular text-decoration-none  mb-0 pb-0"
																	onClick={() => handleApplyNow(position.title)}
																>
																	Apply now{" "}
																</a>
																<span style={{ color: colour }}>
																	<MdKeyboardArrowRight className="fs-5 ms-1" />
																</span>
															</div>
														)}
													</div>
													{showFullDescription.includes(index) && (
														<div className="d-flex d-md-none align-items-center gap-4 mt-3">
															<div className="ms-auto">
																<a
																	onMouseEnter={(e) =>
																		handleMouseEnter(e, colour)
																	}
																	style={{ color: "black", cursor: "pointer" }}
																	onMouseLeave={handleMouseLeave}
																	className="outfit-regular text-decoration-none  mb-0 pb-0"
																	onClick={() => handleApplyNow(position.title)}
																>
																	Apply now{" "}
																</a>
																<span style={{ color: colour }}>
																	<MdKeyboardArrowRight className="fs-5 ms-1" />
																</span>
															</div>
														</div>
													)}
												</div>

												{/* Apply Now Button */}
											</Card.Body>
										</Card>
									</Col>
								);
							})}
						</Row>
					</Col>
				</Row>
			</Container>
		</section>
	);
};

export default Career;
